/** POST 明文上报图片资源 */
export var POST_REPORT_RESOURCE = 'n.gif';

/** 批量 POST 明文上报图片资源 */
export var MULTI_POST_REPORT_RESOURCE = 'o.gif';

// 正式服务上报的图片资源
export var GET_IMAGE_RESOURCE = 'j.gif';

/** 海猫 ACT 协议名 */
export var ACT_PROTOCOL = 'websdkentmaster';

/** Content-Type */
export var CONTENT_TYPE = 'application/x-www-form-urlencoded';

/** K 大小 */
export var K = 1024;
/** 上报大小 */
export var MAX_SIZE = 32 * K;
/** 上报错误 */
export var MAX_SIZE_ERROR = "The query length cannot exceed ".concat(MAX_SIZE / K, "K");
/** 多条上报大小 */
export var MULTI_MAX_SIZE = 48 * K;
/** 多条上报错误 */
export var MULTI_MAX_SIZE_ERROR = "The query length cannot exceed ".concat(MULTI_MAX_SIZE / K, "K");